import React from "react";
import { getWeekdays } from '../helpers/date-helpers';

export const Weekdays = () => {
    const weekdays = getWeekdays('dddd');

    return (
        <ul className="ace-cal-grid-weekdays" aria-hidden="true">
            {
                weekdays.map(weekday => (
                    <li className="ace-cal-grid-weekday">
                        {weekday}
                    </li>
                ))
            }
        </ul>
    )
}